export default __webpack_public_path__ + "static/media/keto_active@2x.266a5804.jpg";